import React, { useEffect, useState } from "react";
import "../CSS/AboutPage.css";
import About from "../Components/About/About";
import Contact from "../Components/Contact/Contact";
import video from "../Components/Assets/about-vid.mp4";

const AboutPage = () => {

  useEffect(()=>{window.scrollTo(0,0);},[]);

  const [showAbout, setShowAbout] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAbout(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="about-page">
      <section className="about-video-section">
        <video className="about-video" autoPlay muted playsInline loop>
          <source src={video} type="video/mp4" />
        </video>
        <div className="video-dark-overlay"></div>
        <div className={`about-overlay ${showAbout ? "show" : ""}`}>
          <About />
        </div>
      </section>
      <Contact />
    </div>
  );
};

export default AboutPage;
